import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { AppCard, AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import useIsMounted from '../../../layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath } from '../../../routing/helpers/router';
import ResourceManagerSidebar from '../../../layout/screenSpecifics/Modules/ResourceManager/Sidebar/ResourceManagerSidebar';
import AppLink from '../../../routing/helpers/AppLink';
import SettingsTabs from '../../../layout/screenSpecifics/Modules/ResourceManager/Settings/SettingsTabs';
import InternalObligationAdd from '../../../layout/screenSpecifics/Modules/ResourceManager/Settings/InternalObligation/InternalObligationAdd';
import colors from '../../../constants/colors';
import Translator from '../../../layout/components/helpers/Translator';
import * as moduleAction from '../../../store/actions/moduleAction';

export default function ModuleResourceManagerSettingsInternalObligationsScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const [obligationAndTemplates, setObligationAndTemplates] = useState();

  // PARA CAMBIAR A FUTURO A COMPONENTE O SIMILAR
    if (!moduleBridgeHex || !moduleData) {
      <AppNoInfo />;
    }
    // > LOAD MODULE DATA //
    const loadModuleData = useCallback(async () => {
      dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_resourceManager_getModuleData'),
          'moduleData',
          {
            moduleBridgeHex,
          },
        ),
      );
    }, []);
  
    useEffect(() => {
        !moduleData && loadModuleData();
      }, []);
    // > LOAD MODULE DATA //
    // < STORE CALLS
    const loadModulePermissions = useCallback(async () => {
      try {
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'permissions',
            {
              moduleBridgeHex,
              subType: 'permissions',
            },
          ),
        );
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'userBridge',
            {
              moduleBridgeHex,
              subType: 'userBridge',
            },
          ),
        );
      } catch (err) {}
    }, [moduleBridgeHex]);
  
    useEffect(() => {
      loadModulePermissions();
    }, [moduleBridgeHex]);
    // < STORE CALLS
    
  // > LOAD INTERNAL OBLIGATIONS
  const loadInternalObligations = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_resourceManager_settings_internalObligation_list"
          ),
          {
            moduleBridgeHex,
          }
        )
        .then(({ data }) => {
          if (isMounted.current) setObligationAndTemplates(data);
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex]
  );

  useEffect(() => {
    loadInternalObligations();
  }, []);
  // < LOAD INTERNAL OBLIGATIONS

  return (
    <>
      <ResourceManagerSidebar activeRoute="user_module_resourceManager_settings_internalObligations" />
      <BreadcrumbHandler
        paths={
          moduleData
            ? [
                {
                  name: `${moduleData?.moduleName}`,
                  route: {
                    name: 'user_module_resourceManager_resource_home',
                    params: {
                      moduleBridgeHex,
                    },
                  },
                },
                {
                  name: ReactDOMServer.renderToString(
                    <Translator
                      file="module-resourceManager"
                      name="resource.configuration.obligations"
                    />
                  ),
                },
              ]
            : [
                {
                  name: '...',
                },
              ]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          <SettingsTabs
            moduleBridgeHex={moduleBridgeHex}
            activeTab="internalObligations"
          />
          <AppCard>
            <InternalObligationAdd
              internalObligationTemplates={
                obligationAndTemplates?.internalObligationTemplates
              }
            />
            {obligationAndTemplates !== undefined ? (
              <div className="mt-3">
                {obligationAndTemplates?.obligations.length > 0 ? (
                  <table className="table table-hover table-sm">
                    <thead>
                      <tr>
                        <th className="col-1">CODE</th>
                        <th className="col-6">
                          <Translator
                            file="module-resourceManager"
                            name="resource.obligation"
                          />
                        </th>
                        <th className="col-4">
                          <Translator
                            file="module-resourceManager"
                            name="resource.frequency"
                          />
                        </th>
                        <th className="col-1">
                          <Translator
                            file="module-resourceManager"
                            name="resource.options"
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {obligationAndTemplates?.obligations.map((obligation) => (
                        <tr key={obligation.hex}>
                          <td>{obligation.hex}</td>
                          <td
                            dangerouslySetInnerHTML={{
                              __html: obligation.obligation,
                            }}
                          />
                          <td
                            dangerouslySetInnerHTML={{
                              __html: obligation.nextDate,
                            }}
                          />
                          <td>
                            <AppLink
                              path="user_module_resourceManager_settings_internalObligation_home"
                              params={{
                                moduleBridgeHex,
                                obligationHex: obligation?.hex,
                              }}
                              title={ReactDOMServer.renderToString(
                                <Translator
                                  file="module-resourceManager"
                                  name="resource.edit"
                                />
                              )}
                            >
                              <AppRemixIcon
                                icon="edit"
                                color={colors.primary}
                                size={16}
                              />
                            </AppLink>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <AppNoInfo
                    text={
                      <Translator
                        file="module-resourceManager"
                        name="resource.no.templates"
                      />
                    }
                    icon={
                      <AppRemixIcon
                        icon="file-unknow"
                        color={colors.grey500}
                        size={44}
                      />
                    }
                    minHeight={250}
                  />
                )}
              </div>
            ) : (
              <AppNoInfo
                text={
                  <Translator
                    file="module-resourceManager"
                    name="resource.loading"
                  />
                }
                minHeight={250}
              />
            )}
          </AppCard>
        </div>
      </main>
    </>
  );
}
